import axios from 'axios'
import html2canvas from 'html2canvas';
import { LangType, Langs, SubmitAddressIdMap, rules } from "./const";
import { i18n } from "../main";
export const isInIntlBrowser = /intlbrowser/i.test(navigator.userAgent);
export const IsTest = location.origin.includes("test") || location.origin.includes('localhost');
// detect navigator share
// todo: files && other
export function canUseNavigatorShare(text: string) {
  return navigator.canShare && navigator.canShare({ text });
}

export function dataURLtoFile(dataurl:any, filename:string) {
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return {
    file: new File([u8arr], filename, { type: mime }),
    blob: new Blob([u8arr], { type: mime }),
  };
}

export enum LoginErrorCode {
  ACCOUNT_NOT_VALID = 2001,
  ACCOUNT_NOT_EXIST = 2200,
  ACCOUNT_NOT_RIGHT = 2002,
  PASSWORD_EMPTY = 2108,
  PASSWORD_NOT_SET = 808099001,
}

export const getErrMessage = (code: LoginErrorCode) => {
  const map = {
    [LoginErrorCode.ACCOUNT_NOT_VALID]: i18n.t('account_not_exist'),
    [LoginErrorCode.ACCOUNT_NOT_EXIST]: i18n.t('account_not_exist'),
    [LoginErrorCode.PASSWORD_EMPTY]: i18n.t('password_empty'),
    [LoginErrorCode.ACCOUNT_NOT_RIGHT]: i18n.t('pls_input_info'),
    [LoginErrorCode.PASSWORD_NOT_SET]: i18n.t('pls_input_info'),

  }
  return map[code] ?? i18n.t('error');
}

export function getLang(): LangType {
  for (let lang of Langs) {
    if (location.pathname.endsWith(`${lang}/`) || location.pathname.endsWith(`${lang}/index.html`)) {
      return lang;
    }
  }
  return "en";
}

export function urlparamsToObject() {
  const res: Record<string, string> = {};
  const urlparams = new URLSearchParams(location.search);
  urlparams.forEach((val, key) => {
    res[key] = val;
  });
  return res;
}

export function getSpecialBrowserType() {
  const uaTester = (regs: RegExp[]) => Boolean(regs.find((reg) => reg.test(navigator.userAgent)));
  if (uaTester([/fbav/i, /fban/i])) {
    return 'facebook';
  }
  if (uaTester([/naver/i, /fban/i])) {
    return 'naver';
  }
  if (uaTester([/bytelo/i, /bytedance/i])) {
    return 'tictok';
  }
  if (uaTester([/microm/i, /wechat/i])) {
    return 'wechat';
  }
  if (uaTester([/vivobrowser/i, /vivo/i])) {
    return 'vivo';
  }
  if (uaTester([/mibrowser/i, /xiaomi/i, /miui/i])) {
    return 'mi';
  }
  if (uaTester([/discord/i])) {
    return 'discord';
  }
  if (uaTester([/kakao/i, /kakaotalk/i])) {
    return 'kakao';
  }
  if (uaTester([/line/i])) {
    return 'line';
  }
  if (uaTester([/instagram/i])) {
    return 'ins';
  }
  return '';
}

export function appendScript(script: string) {
	return new Promise((resolve, reject) => {
		const head = document.getElementsByTagName("head")[0];
		const wsScript = document.createElement("script");
		wsScript.type = "text/javascript";
		wsScript.src = script;
	
		head.appendChild(wsScript);
		const scriptLoaded = (e: Event) => {
			wsScript.removeEventListener("load", scriptLoaded);
			resolve(e);
		};
		const scriptLoadFailed = (e: Event) => {
			wsScript.removeEventListener("error", scriptLoadFailed);
			reject(e);
		};
		wsScript.addEventListener("load", scriptLoaded);
		wsScript.addEventListener("error", scriptLoadFailed);
		wsScript.addEventListener("abort", scriptLoadFailed);
	});
}

export function appendLink(script: string) {
	return new Promise((resolve, reject) => {
		const head = document.getElementsByTagName("head")[0];
		const wsScript = document.createElement("link");
		wsScript.rel = "stylesheet";
		wsScript.href = script;
	
		head.appendChild(wsScript);
		const scriptLoaded = (e: Event) => {
			wsScript.removeEventListener("load", scriptLoaded);
			resolve(e);
		};
		const scriptLoadFailed = (e: Event) => {
			wsScript.removeEventListener("error", scriptLoadFailed);
			reject(e);
		};
		wsScript.addEventListener("load", scriptLoaded);
		wsScript.addEventListener("error", scriptLoadFailed);
		wsScript.addEventListener("abort", scriptLoadFailed);
	});
}


export async function imageToBase64(url: string) {
  // 获取图片的二进制数据
  const { data } = await axios.get(url, { responseType: 'blob' })
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = (event: any) => {
      /// 转换结束回调
      try {
        // data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEASABIAAD…9UoI0d6BOexAMoAdfWgzKBJQDTtQJPFAECCgB8UAzoUH/2Q==
        const fullImgBase64 = event.target.result ?? ''
        const imgBase64 = fullImgBase64?.split('base64,')[1] ?? ''
        resolve(fullImgBase64)
      } catch (e) {
        reject(e)
      }
    }
    // 读取 图片 二进制数据 转成 base64
    reader.readAsDataURL(data)
  })
}

export async function domToCanvas(dom: HTMLElement, options: any) {
  const canvas = await html2canvas(dom, {
    ...options,
    logging: false,
    useCORS: true,
    allowTaint: false,
    // removeContainer: !(import.meta.env.MODE === 'development'),
    backgroundColor: '#ffffff',
    // swiper
    ignoreElements: (node) => {
      const isHead = document.head.contains(node);
      const isParent = node.contains(dom);
      const isChild = dom.contains(node);
      return !(isHead || isParent || isChild);
    },
  });
  return canvas;
}

export async function domToBase64(dom: HTMLElement, options: any) {
  const { type = 'image/jpeg', compress_rate = 1, target_size, ...rest  } = options || {};
  const canvas = await domToCanvas(dom, rest);
  function getURISize(datauri: string) {
    return Math.round(datauri.length * 3 / 4);
  }
  let uri;
  let temp_rate = compress_rate;
  uri = canvas.toDataURL(type, compress_rate);
  // 获取指定大小
  if (target_size) {
    while (getURISize(uri) >= target_size && temp_rate > 0) {
      // 每次5%
      temp_rate -= 0.05;
      uri = canvas.toDataURL(type, temp_rate);
    }
  }
  return uri;
}

export const JumpUrl = {
  Donload: {
    ios: {
      en: "https://taris.onelink.me/MIYM/ojtwgqyr",
      ru: "https://taris.onelink.me/MIYM/nwvvqqry",
    }[getLang()],
    android: {
      en: "https://taris.onelink.me/MIYM/ojtwgqyr",
      ru: "https://taris.onelink.me/MIYM/nwvvqqry",
    }[getLang()],
  },
  Subscribe: {
    en: "https://taris.onelink.me/MIYM/ojtwgqyr",
    ru: "https://tarisglobal.com/ru/",
  }[getLang()],
  OfficalMedia: {
    en: "https://x.com/Taris_Official",
    ru: "https://vk.com/tarislandcis",
  }[getLang()],
  Discord: {
      en: "https://discord.com/invite/yEvyYmShYT",
      ru: "https://discord.gg/tarislandcis",
  }[getLang()],
  Download: "https://tarisglobal.com/download/TARISMiniLoader_official.wg.intl.exe",
  DownloadApk: "https://tarisglobal.com/download/apk/",
};

function showInputTips(key: string, value: string) {
  const domId = SubmitAddressIdMap[key as keyof typeof SubmitAddressIdMap];
  const dom = window.$(domId)?.next();
  if (!dom) return;
  if (!value) {
    dom.hide();
    return;
  }
  dom.text(value).show();
}
export function checkKeyInput(key: string, val: string, langData: Record<string, string>) {
  const rule = rules[key as keyof typeof rules] || [];
  if (!rule) return true;
  for (const ruleInfo of rule) {
    const { message: text } = ruleInfo;
    const message = langData[text] || text;
    if (ruleInfo.required && !val) {
      showInputTips(key, message);
      return false;
    }
    if (ruleInfo.min && val.length < ruleInfo.min) {
      showInputTips(key, message);
      return false;
    }
    if (ruleInfo.max && val.length > ruleInfo.max) {
      showInputTips(key, message);
      return false;
    }
    if (ruleInfo.regex) {
      const regex = new RegExp(ruleInfo.regex);
      if (!regex.test(val)) {
        showInputTips(key, message);
        return false;
      }
    }
    showInputTips(key, "")
  }
  return true;
}


export async function getServerInfo() {
  if (!(window as any).TRSSJServerSelect){
    await appendScript('https://trl.tarisglobal.com/game_area/en/trssj_server_select_utf8.js');
  };
  return (window as any).TRSSJServerSelect;
}

export async function getSeverList() {
  const serverLangMap = {
    en: ["12", "13", "14"],
    ru: ['15'],
  };

  const serverInfo = await getServerInfo();
  let serverList = serverLangMap[getLang()];
  if (IsTest) {
    serverList = ['59'];
  }
  return serverList.map(serverId => {
    const area = serverInfo.STD_CHANNEL_DATA.find((item: any) => item.v === serverId);
    const server = serverInfo.STD_DATA.filter((item: any) => item.c === serverId);
    return {
      ...area,
      server,
    }
  });
}
export async function getZoneList() {
  const serverLangMap = {
    en: ["12", "13", "14"],
    ru: ['15'],
  };

  const serverInfo = await getServerInfo();
  let serverList = serverLangMap[getLang()];
  // if (IsTest) {
  //   serverList = ['59'];
  // }
  const zoneInfoMap = new Map();
  const STD_DATA = serverInfo?.STD_DATA || []
  for (const std of STD_DATA) {
    if (!serverList.includes(std.c)) continue;
    zoneInfoMap.set(std.v, std);
  }
  return zoneInfoMap;
}
export function debounce<T extends (...args: any[]) => any>(
  func: T,
  wait: number,
): (...args: Parameters<T>) => void {
  let timeout: ReturnType<typeof setTimeout> | null = null;

  return function (this: ThisParameterType<T>, ...args: Parameters<T>) {
    const later = () => {
      timeout = null;
      func.apply(this, args);
    };
    if (timeout !== null) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(later, wait);
  };
}

export function formatSeconds(seconds:number) {
  try {
    const second = Math.floor(Number(seconds) / 1000);
    const minutes = Math.floor(second / 60).toString().padStart(2, '0');
    const remainingSeconds = (second % 60).toString().padStart(2, '0');
    return `${minutes}:${remainingSeconds}`;
  } catch (error) {
    console.log(error);
    return;
  }
}